export default function CouncilBluffsLocalAreaSection() {
  const cities = [
    { name: "Council Bluffs", zips: "51501, 51502, 51503" },
    { name: "Omaha, NE (Metro)", zips: "68102, 68108, 68105" },
    { name: "Carter Lake", zips: "51510" },
    { name: "Treynor", zips: "51575" },
    { name: "Macedonia", zips: "51549" },
  ];

  return (
    <section id="service-area" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">Serving Council Bluffs &amp; the Omaha Metro</h2>
        </div>
        <div className="max-w-4xl mx-auto mb-16">
          <div className="bg-[#F7F8FA] rounded-lg p-8 md:p-10 border border-gray-200">
            <p className="text-gray-600 text-base leading-[1.8] mb-5">Council Bluffs is the Iowa half of one of the Midwest's most integrated bi-state metropolitan areas. With Omaha directly across the Missouri River, Council Bluffs residents regularly commute to Nebraska for work and access a shared regional economy that includes major logistics hubs, healthcare institutions, and financial services companies with active international operations.</p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">The city's casino resort corridor — Harrah's, Horseshoe, and Ameristar — employs a large hospitality workforce that includes entertainment professionals and event staff who travel internationally for industry events, conventions, and corporate meetings. These workers often discover passport needs when an overseas trip gets confirmed on short notice.</p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">Council Bluffs also serves as the western gateway for Southwest Iowa families who travel to Omaha Eppley Airfield for international flights. A missed or expired passport discovered at check-in — or discovered when booking an international flight through Eppley — is one of the most common emergency scenarios we see from this area.</p>
            <p className="text-gray-600 text-base leading-[1.8]">Fast Passport Center serves Council Bluffs and the entire Southwest Iowa corridor with the same expedited, professional service available nationally. Start online, ship overnight from anywhere in Pottawattamie County, and receive your passport without driving to Des Moines.</p>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div>
            <div className="bg-[#1A365D] rounded-lg p-7 mb-8 text-white">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0"><i className="ri-passport-line text-[#1A365D] text-xl"></i></div>
                <div><p className="font-bold text-base">Fast Passport Center — Omaha Office</p><p className="text-white/60 text-xs mt-0.5">1601 Dodge St, Omaha, NE 68102</p></div>
              </div>
              <p className="text-white/70 text-sm mb-1">
                <i className="ri-map-pin-line text-[#F6C344] mr-1.5"></i>
                By appointment only — sign up on our website first to schedule
              </p>
              <p className="text-white/50 text-xs mb-5 ml-5">Walk-ins are not accepted. Schedule online then visit our downtown Omaha office — a quick drive across the Missouri River from Council Bluffs.</p>
              <div className="border-t border-white/10 pt-5">
                <p className="text-white/80 text-sm leading-relaxed mb-4">
                  After signing up online, schedule your appointment to visit our office at <strong className="text-white">1601 Dodge St in downtown Omaha</strong> — just 10 minutes from Council Bluffs across the Missouri River via I-480. Appointments are required — no walk-ins. Or choose <strong className="text-white">overnight shipping</strong> with our prepaid label from any UPS/FedEx in Council Bluffs if you prefer not to visit in person.
                </p>
                <a href="https://fastpassportcenter.com/checkout/" className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap">Start My Passport <i className="ri-arrow-right-line"></i></a>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {[
                { icon: "ri-computer-line", title: "Start 100% Online", desc: "Complete your order from home, office, or anywhere in Southwest Iowa." },
                { icon: "ri-truck-line", title: "Ship Your Documents", desc: "Overnight shipping from any UPS or FedEx location in Council Bluffs." },
                { icon: "ri-shield-check-line", title: "Expert Document Review", desc: "Every application reviewed before submission to reduce errors." },
                { icon: "ri-calendar-check-line", title: "Reserved Agency Access", desc: "We hold reserved submission slots — no public appointment needed." },
              ].map((b, i) => (
                <div key={i} className="bg-[#F7F8FA] rounded-lg p-5 border border-gray-200">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-3"><i className={`${b.icon} text-[#1A365D] text-base`}></i></div>
                  <p className="font-bold text-[#1A365D] text-sm mb-1">{b.title}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>
          <div>
            <div className="bg-[#F7F8FA] rounded-lg p-7 mb-6 border border-gray-200">
              <h3 className="font-bold text-[#1A365D] text-sm uppercase tracking-wide mb-5"><i className="ri-map-pin-2-line text-[#F6C344] mr-2"></i>Communities We Serve</h3>
              <div className="space-y-1.5">
                {cities.map((city, i) => (
                  <div key={i} className="flex items-center justify-between py-2.5 px-3 bg-white rounded-md">
                    <div className="flex items-center gap-2.5"><i className="ri-checkbox-circle-fill text-[#F6C344] text-sm"></i><span className="text-[#1A365D] font-medium text-sm">{city.name}</span></div>
                    <span className="text-gray-400 text-xs font-mono hidden sm:inline">{city.zips}</span>
                  </div>
                ))}
              </div>
              <p className="text-gray-500 text-xs mt-4 leading-relaxed">Anywhere in Southwest Iowa or the Omaha metro area — start online, ship overnight, and we handle the rest.</p>
            </div>
            <div className="bg-[#1A365D] rounded-lg p-5">
              <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-4">Why Council Bluffs Travelers Choose Fast Passport Center</p>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: "ri-government-line", value: "Registered Courier", label: "U.S. Department of State" },
                  { icon: "ri-award-line", value: "A+ Rating", label: "Better Business Bureau" },
                  { icon: "ri-calendar-check-line", value: "20+ Years", label: "Serving Travelers Nationwide" },
                  { icon: "ri-customer-service-2-line", value: "Real Humans", label: "Live Support — Not a Bot" },
                ].map((item, i) => (
                  <div key={i} className="flex items-center gap-2.5 bg-white/5 hover:bg-white/10 rounded-md px-3 py-2.5 transition-colors">
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0"><i className={`${item.icon} text-sm text-[#F6C344]`}></i></div>
                    <div className="text-left"><span className="text-white text-xs font-bold block leading-tight">{item.value}</span><span className="text-white/50 text-xs leading-tight block">{item.label}</span></div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="mt-16">
          <div className="text-center mb-8">
            <p className="text-[#1A365D] font-serif text-2xl md:text-3xl font-bold mb-2">
              Visit Our Omaha Office
            </p>
            <p className="text-gray-500 text-sm max-w-lg mx-auto">
              Fast Passport Center — 1601 Dodge St, Omaha, NE 68102
            </p>
          </div>
          <div className="rounded-lg overflow-hidden border border-gray-200 shadow-sm">
            <iframe
              src="https://www.google.com/maps?q=1601+Dodge+St,+Omaha,+NE+68102&output=embed"
              title="Fast Passport Center Omaha Office Location"
              className="w-full h-[400px] md:h-[500px]"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
          <div className="mt-4 text-center">
            <a
              href="https://www.google.com/maps/dir/?api=1&destination=1601+Dodge+St,+Omaha,+NE+68102"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2440] text-white font-medium text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
            >
              <i className="ri-navigation-line"></i>
              Get Directions
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}